export default __webpack_public_path__ + "static/assets/icon_lungs.5230ec7c.png";